import React from "react";
import { FAQ_IMG01, FAQ_IMG02 } from "../../lib/assets";

const expectations = [
  {
    id: "contactExpect1",
    question: "What happens after I contact Silverwave?",
    answer:
      "We reply within one business day to book a free 20-minute health check. On the call we look at where your books stand, then send you a fixed monthly quote. There's no obligation.",
  },
  {
    id: "contactExpect2",
    question: "Do you meet in person?",
    answer:
      "Yes. We meet clients in person in Surrey, or online if that's easier for you.",
  },
  {
    id: "contactExpect3",
    question: "What should I have ready for the health check?",
    answer:
      "Just a rough idea of how many transactions you have each month, which software you use (if any), and how up to date your books are.",
  },
];

export const ContactExpectArea = () => {
  return (
    <section className="faq-area contact-expect" id="faq">
      <div className="faq-bg-shape"></div>
      <div className="container">
        <div className="row align-items-start justify-content-center">
          <div className="col-lg-6 col-md-9">
            <div className="faq-img-wrap">
              <img
                src={FAQ_IMG01}
                alt="Business owner asking a bookkeeper questions"
              />
              <img
                src={FAQ_IMG02}
                alt="Bookkeeper explaining a monthly report"
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="faq-content">
              <div className="section-title mb-30">
                <span className="sub-title">Before You Reach Out</span>
                <h2 className="title">What to Expect</h2>
              </div>
              <p>Here's how getting started with Silverwave works.</p>
              <div className="accordion-wrap">
                <div className="accordion" id="contactExpect">
                  {expectations.map((item, index) => {
                    const isOpen = index === 0;

                    return (
                      <div className="accordion-item" key={item.id}>
                        <h3 className="accordion-header">
                          <button
                            className={`accordion-button${isOpen ? "" : " collapsed"}`}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#${item.id}`}
                            aria-expanded={isOpen}
                            aria-controls={item.id}
                          >
                            {item.question}
                          </button>
                        </h3>
                        <div
                          id={item.id}
                          className={`accordion-collapse collapse${isOpen ? " show" : ""}`}
                          data-bs-parent="#contactExpect"
                        >
                          <div className="accordion-body">
                            <p>{item.answer}</p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
